import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { Link } from './Link';

const Root = styled.div`
  width: calc(${globalTheme.spacing.lg} * 8);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > * {
    margin-bottom: ${globalTheme.spacing.xs};
  }
`;

export const Links: FC = () => {
  const analytics = useAnalytics();

  return (
    <Root>
      <Link
        href="https://cloudinary.com/tos"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analytics('navigation', 'terms of use')}
        data-test="footer-terms-of-use-link"
      >
        <FormattedMessage {...messages['landing.footer.links.termsOfUse']} />
      </Link>
      <Link
        href="https://cloudinary.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analytics('navigation', 'privacy policy')}
        data-test="footer-privacy-policy-link"
      >
        <FormattedMessage {...messages['landing.footer.links.privacyPolicy']} />
      </Link>
      <Link
        href="https://cloudinary.com/documentation"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analytics('navigation', 'documentation')}
        data-test="footer-documentation-link"
      >
        <FormattedMessage {...messages['landing.footer.links.documentation']} />
      </Link>
    </Root>
  );
};
